module.exports = __webpack_public_path__ + "static/media/website-16.5f1f36b2.png";